import { render, staticRenderFns } from "./talks.vue?vue&type=template&id=509f56ed&scoped=true"
import script from "./talks.vue?vue&type=script&lang=js"
export * from "./talks.vue?vue&type=script&lang=js"
import style0 from "./talks.vue?vue&type=style&index=0&id=509f56ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f56ed",
  null
  
)

export default component.exports